import { CodePromo, UnifiedTarifContainer } from '@workspace/core-ts/components';
import { veloVariant } from '@/config/tarif-variant';

export default function TarifWithPromo() {
    return (
        <UnifiedTarifContainer variant={veloVariant} className="max-w-4xl">
            {/* Composant Code Promo */}
            <CodePromo
                labels={{
                    title: 'Vous avez un code promo ?',
                    titleMobile: 'Vous avez<br />un code promo ?',
                    placeholder: 'Code promo',
                    buttonText: 'Valider',
                    errorMessage: "Le code promo n'est pas valide.",
                    successMessage: 'Le code promo a bien été appliqué.',
                }}
                onCodePromoValidated={(data) => {
                    console.log('Code promo validé:', data);
                    // Le tarif sera automatiquement mis à jour dans le formulaire
                }}
            />
        </UnifiedTarifContainer>
    );
}
